/**
 * Password rules from the Figma change-password checklist. The same list
 * drives both the zod schema and the live checklist UI, so the two can
 * never drift apart.
 */
export const PASSWORD_CRITERIA = [
  { key: "minLength", test: (value: string) => value.length >= 12 },
  {
    key: "mixedCase",
    test: (value: string) => /[a-z]/.test(value) && /[A-Z]/.test(value),
  },
  { key: "digit", test: (value: string) => /\d/.test(value) },
  { key: "specialChar", test: (value: string) => /[^a-zA-Z0-9\s]/.test(value) },
] as const;

export type PasswordCriterionKey = (typeof PASSWORD_CRITERIA)[number]["key"];

export function meetsAllPasswordCriteria(value: string): boolean {
  return PASSWORD_CRITERIA.every((criterion) => criterion.test(value));
}
